export const environment = {
  production: false,
  name: 'lab',

  // APIM Gateway URL - Lab environment in Azure
  apiUrl: 'https://fn-wst-lospaisitas-arena-lab.azurewebsites.net/api',

  // API Endpoints (APIM routes)
  api: {
    // Command APIs (Write operations)
    organizations: '/arena/api/organizations',
    tournaments: '/arena/api/tournaments',
    competitions: '/arena/api/competitions',
    venues: '/arena/api/venues',
    tenants: '/arena/api/tenants',
    sportsConfig: '/arena/api/sports-config',

    // Query APIs (Read operations)
    organizationsRead: '/arena/read/api/organizations',
    tournamentsRead: '/arena/read/api/tournaments',
    competitionsRead: '/arena/read/api/competitions',
    venuesRead: '/arena/read/api/venues',
    tenantsRead: '/arena/read/api/tenants',
  },

  // WebSocket URL (if needed for real-time features)
  wsUrl: 'wss://apim-wst-transversal-lab.azure-api.net',

  // Application Info
  appName: 'WeSportech Arena Portal - LAB',
  version: '1.0.0-lab',

  // Feature Flags
  features: {
    enableDebugMode: true,
    enableMockData: false,
    enableAnalytics: true,
  },

  // Azure Entra ID Configuration (MSAL)
  msalConfig: {
    auth: {
      clientId: 'e4611ba2-693d-48b9-8084-9eeecfba1f52',
      authority: 'https://login.microsoftonline.com/4a24d27e-e46c-48c6-b3f8-4b1f0b04e1aa',
      redirectUri: 'https://arenalab.lospaisitas.co',
      postLogoutRedirectUri: 'https://arenalab.lospaisitas.co',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  },
  apiScopes: ['User.Read'],

  // Security Groups (Object IDs from Entra ID)
  securityGroups: {
    admin: '1ec9ae50-e120-4f78-b4c3-984e1d4d0bc1',
  },

  // Azure Configuration
  azure: {
    subscriptionId: '43485bd6-c9a6-4c52-b80b-6c6aa317dcab',
    resourceGroup: 'rg-wst-arena-lab',
    apimName: 'apim-wst-transversal-lab',
    apimResourceGroup: 'rg-wst-transversal-lab',
  },
};
